import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationsService } from '../../services/organizations.service';
import { PermissionsService } from '../../services/permissions.service';
import { UsersService } from '../../services/users.service';
import { passwordMatchValidator } from '../../validators/password-match-validator.validator';
import { User } from '../../models/user.model';
import { Organization } from '../../models/organization.model';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../services/notification.service';


@Component({
  selector: 'app-edit-user',
  standalone: true,
  imports: [
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatRadioModule,
    CommonModule
  ],
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.css'
})
export class EditUserComponent implements OnInit {

  public userId: number = 0;
  public user: User = new User(0, '', '', '', 0, '', '');

  public organizations: Organization[] = [];

  public editForm = new FormGroup({
    id: new FormControl(0, [Validators.required]),
    name: new FormControl("", [Validators.required]),
    surname: new FormControl("", [Validators.required]),
    organization_id: new FormControl("", []),
    //email: new FormControl("", [Validators.required]),
    phone: new FormControl("", []),
    is_admin: new FormControl(0, [Validators.required]),
  },
    {
      //validators: this.passwordMatchValidator
    }
  )

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public permissionsService: PermissionsService,
    public organizationsService: OrganizationsService,
    public usersService: UsersService,
    private notificationService: NotificationService,


  ) {
  }

  ngOnInit(): void {

    this.organizationsService.fetchOrganizations()
      .subscribe({
        next: (data: any) => {
          this.organizations = data;
        },
        error: (error: any) => {
          console.error(error);
        }
      });

    this.userId = this.route.snapshot.params['userId'];
    this.usersService.getUser(this.userId)
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.user = response.user;

          this.usersService.setCurrentUser(this.user);
          this.editForm.patchValue(this.user);
        },
        error: (error) => {
          console.log(error);
          if (error.status === 401) {
            this.router.navigate(['/login']);
          }
        }
      });

    //this.user = this.usersService.getCurrentUser()
    //this.editForm.patchValue(this.user);
  }

  onSubmit() {
    console.log(this.editForm.value);

    if (this.editForm.valid) {
      const user = {
        id: this.editForm.value.id,
        name: this.editForm.value.name,
        organization_id: this.editForm.value.organization_id,
        surname: this.editForm.value.surname,
        //email: this.editForm.value.email,
        phone: this.editForm.value.phone,
        is_admin: this.editForm.value.is_admin,
        //recbot_api_token: this.editForm.value.recbot_api_token,
        //password: this.editForm.value.password,
        //password_confirmation: this.editForm.value.password_confirmation
      }
      this.usersService.updateUser(user)
        .subscribe({
          next: (response: any) => {
            console.log(response);
            this.notificationService.pushNotification(
              `Dane zapisane`, 'info', 5000);
  
            this.router.navigate(['/users-list']);
          },
          error: (error) => {
            console.log(error);
            if (error.status === 401) {
              this.router.navigate(['/login']);
            }
            this.notificationService.pushNotification(
              `Problem z zapisaniem danych`, 'error', 5000);

          }
        });
    }
  }
}
